import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql, Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import { Helmet } from "react-helmet";

import ContentModule from "../modules/content_module";
import Layout from "../components/Layout"
import InsightDetails from "../components/NewsInsight/InsightDetails";
import Subscribe from "../components/Subscribe/Subscribe";
import { breadcrumbs } from "../common/utils/breadcrumbs";
import PlayVideo from "../modules/video_module/PlayVideo";
import News from "../components/News/News"
import { PageLinks } from "../common/page-links";
import { NewsDetails } from "../common/queries/common_use_query"
import PreLoader from "../modules/pre-loader"
import { site_name } from "../common/constant";
import { toCapitalize} from "../common/utils/site_utlis";
import ImageModule from "../modules/image_module";

import _ from "lodash";

const NewsDetailTemplate = ({data}) => {

  //const[blog, setBlog] = useState("");

  //const { loading, error, data } = NewsDetails(props.pageContext.slug);

  const { glstrapi: { blog } } = data;

  // useEffect(()=>{
  //   data?.blogs?.length > 0 && setBlog(data?.blogs[0]);
  // },[data])
  //console.log('blog', blog)
  const bread = [
    { label: 'About', slug: PageLinks.about },
    { label: 'News and Views', slug: PageLinks.news_insight }, 
    { label: blog?.title ? blog?.title : "", slug: blog?.slug ? blog?.slug : "" }
  ]
  const breadcrumbsList = breadcrumbs(null, bread);
  let [isPlay, setPlay] = React.useState(false);
  //console.log('blog', blog)

  var imagename = "blog.banner_image.details";

  let processedImages = JSON.stringify({});
  if (blog?.imagetransforms?.banner_image_Transforms) {
      processedImages = blog?.imagetransforms?.banner_image_Transforms;
  }

  var meta_title = blog?.title ? (blog?.seo?.title ? blog?.seo?.title : toCapitalize(blog?.title)) : "";
  var meta_desc = blog?.title ? (blog?.seo?.description ? blog?.seo?.description : `Read about ${blog?.title.toLowerCase()} here and subscribe to our newsletter to stay up-to-date about everything going on at ${site_name}.`) : ""

  var ldJson = `{
    "@context": "http://schema.org",
    "@type": "NewsArticle",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "${process.env.GATSBY_SITE_URL}/${PageLinks.news_insight}/${blog?.slug}"
    },
    "headline": "${blog?.title}",
    "image": "${blog?.banner_image ? blog?.banner_image.url : ""}",
    "publisher": {
      "@type": "Organization",
      "name": "${site_name}",
      "logo": {
        "@type": "ImageObject",
        "url": "${process.env.GATSBY_SITE_URL}/images/mail-logo.png"
      }
    },
    "description": "${meta_desc}"
  }`

  
  return (
    // loading ? 
    //   <PreLoader />
    // :
    <div className="search-header property-header news-page news-detail-page">
      {blog?.title &&
      <Layout seo_meta={{
        title: meta_title,
        description: meta_desc,
        image: blog?.banner_image
      }}
        menu_slug={"news-details"}
      >

        <Helmet>
            <script  type="application/ld+json">{ldJson}</script>
        </Helmet>

        <InsightDetails {...blog} breadcrumbs={breadcrumbsList} />

        <section className="static-details" >
          <Container>
            <Row>
              <Col lg={8}>
                <div className="details-wrap">
                  <div className="video-img">
                    {/* <img src={blog?.banner_image?.url} alt={blog?.banner_image?.alternativeText ? blog?.banner_image?.alternativeText : blog?.title} /> */}

                    <ImageModule ImageSrc={blog?.banner_image} altText={blog?.banner_image?.alternativeText ? blog?.banner_image?.alternativeText : blog?.title} imagetransforms={processedImages} ggfx_results={blog?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={blog?.id}/>

                    {blog?.embed_video_url &&

                      <button className="video-wrap"
                        onClick={e => {
                          setPlay(true)
                        }}>
                        <i className="icon-video">
                        </i>
                      </button>

                    }
                  </div>

                  <ContentModule Content={blog?.description} />
                </div>
              </Col>

              <Col lg={4}>
                <section className="inner-wrap">
                  <Subscribe />
                </section>
              </Col>
            </Row>
          </Container>
        </section>
        <PlayVideo
          isOpen={isPlay}
          isCloseFunction={setPlay}
          videoUrl={blog?.embed_video_url}
          isAutoPlay={1}
        />

        <News Module={{ Title: 'May also interest you...' }} />

      </Layout>
      }
    </div>
  )

}

export default NewsDetailTemplate


export const query = graphql`
query newsDetailQuery($id: ID!) {
    glstrapi { 
      blog(id: $id, publicationState: LIVE) {
          id
          title
          description
          categories
          tags
          embed_video_url
          slug
          createdAt
          post_on
          banner_image {
            alternativeText
            url
          }
          author {
            name
          } 
          seo {
            title
            keywords
            description
            id
            image {
              alternativeText
              url
            }
          }
          imagetransforms
          ggfx_results {
            id
            content_type
            transforms
            src_import_url
            src_cftle
            field
          }
      } 
    }
}`